import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { OfficeCTA } from './OfficeCTA';
import { RestoCTA } from './RestoCTA';
import { NightclubCTA } from './NightclubCTA';

export const ThemeAwareCTA: React.FC = () => {
  const { theme } = useTheme();
  
  if (theme === 'nightclub') return <NightclubCTA />;
  if (theme === 'resto') return <RestoCTA />;
  return <OfficeCTA />;
};